export default function Accordion ({ visible, collapse, onlyOneOpened = false}) {
	$(collapse).hide()

	$(visible).on('click', function () {
		let self = $(this)

		if (!onlyOneOpened) {
			self.toggleClass('active').next().slideToggle(300)
		} else {
			$(visible).not(self).removeClass('active').next().slideUp(300)
			self.toggleClass('active').next().slideToggle(300)
		}
	})
}